import { render, staticRenderFns } from "./Games.vue?vue&type=template&id=5ba811e8&scoped=true&"
import script from "./Games.vue?vue&type=script&lang=ts&"
export * from "./Games.vue?vue&type=script&lang=ts&"
import style0 from "./Games.vue?vue&type=style&index=0&id=5ba811e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba811e8",
  null
  
)

export default component.exports